<template>
  <div class="password-validator">
    <div ref="dropButton">
      <slot></slot>
    </div>
    <div class="validator-dropdown" ref="dropdown" v-show="$props.visible">
      <transition name="slide" mode="out-in">
        <div class="dropdown-container" v-if="$props.visible">
          <h5 class="title">{{ $t('passwordValidationDropdown.title') }}</h5>
          <ul class="password-rules">
            <li :class="minLength ? 'error' : 'pass'">
              <i :class="minLength ? 'icon-sc-x' : 'icon-sc-check'"></i>
              {{ $t('passwordValidationDropdown.minLength') }}
            </li>
            <li :class="uppercaseLetter ? 'error' : 'pass'">
              <i :class="uppercaseLetter ? 'icon-sc-x' : 'icon-sc-check'"></i>
              {{ $t('passwordValidationDropdown.uppercaseLetter') }}
            </li>
            <li :class="lowercaseLetter ? 'error' : 'pass'">
              <i :class="lowercaseLetter ? 'icon-sc-x' : 'icon-sc-check'"></i>
              {{ $t('passwordValidationDropdown.lowercaseLetter') }}
            </li>
            <li :class="specialCharOrNum ? 'error' : 'pass'">
              <i :class="specialCharOrNum ? 'icon-sc-x' : 'icon-sc-check'"></i>
              {{ $t('passwordValidationDropdown.specialCharOrNum') }}
            </li>
          </ul>
          <div class="validator-popper-arrow" ref="arrow" v-if="$props.visible"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  name: 'validate-password-dropdown',
  data () {
    return {
      popperjs: null
    }
  },
  props: {
    password: String,
    visible: Boolean
  },
  computed: {
    minLength () {
      return this.$props.password.length < 7
    },
    uppercaseLetter () {
      const uppercaseRegex = new RegExp('(?=.*[A-Z])')
      return !uppercaseRegex.test(this.$props.password)
    },
    lowercaseLetter () {
      const lowercaseRegex = new RegExp('(?=.*[a-z])')
      return !lowercaseRegex.test(this.$props.password)
    },
    specialCharOrNum () {
      const regex = new RegExp('((?=.*[0-9])|(?=.*[~"\'!@#$%^&*]))')
      return !regex.test(this.$props.password)
    }
  },
  methods: {
    createPopup () {
      const drop = this.$refs.dropButton
      const dropdown = this.$refs.dropdown
      const arrow = this.$refs.arrow
      this.$nextTick(() => {
        this.popperjs = createPopper(drop, dropdown, {
          placement: 'bottom',
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['top', 'left'],
                padding: 5,
                rootBoundary: 'viewport',
                allowedAutoPlacements: ['bottom', 'top']
              }
            },
            {
              name: 'offset',
              options: {
                offset: [0, -18]
              }
            },
            {
              name: 'preventOverflow'
            },
            {
              name: 'arrow',
              options: {
                element: arrow,
                padding: 5
              }
            }
          ]
        })
      })
    },
    closePopup () {
      if (this.popperjs) {
        this.popperjs.destroy()
      }
      this.popperjs = null
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) this.createPopup()
      else this.closePopup()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.createPopup()
    })
  }
}
</script>

<style scoped lang="scss">
.password-validator {
  position: relative;
}

.validator-dropdown {
  z-index: 99;
  display: block;
  width: 100%;
  max-width: 400px;

  .dropdown-container {
    background-color: $white;
    padding: 2rem 1.6rem;
    box-shadow: 2px 0 20px 0 rgba(0, 0, 0, 0.16);
    border-radius: .5rem;
    text-align: left;
    position: relative;

    .title {
      font-size: 1.2rem;
      font-weight: 600;
      color: $light-black;
      margin-bottom: .8rem;
    }

    .password-rules {
      padding: 0;
      margin: 0;
      list-style: none;

      li {
        font-size: 1.2rem;
        line-height: 2.5;
        vertical-align: middle;

        i {
          margin-right: 1.4rem;
          vertical-align: middle;
        }

        &.error {
          color: $error;
        }

        &.pass {
          color: $success;
        }
      }
    }
  }
}
</style>
